import { ArrowRight, MoveRight } from "lucide-react";
import { Button } from "./ui/button";
import { HERO } from "../mock";

export default function Hero() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="overview" className="relative min-h-screen flex items-center pt-32 pb-24 overflow-hidden">
      {/* Ambient background */}
      <div className="absolute inset-0 grid-lines opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#04100f] via-[#04120f]/60 to-[#04100f]" />
      <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-teal-500/10 blur-[120px]" />
      <div className="absolute top-1/3 -right-40 h-[480px] w-[480px] rounded-full bg-emerald-500/8 blur-[130px]" />

      <div className="relative max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-4xl">
          <div className="reveal inline-flex items-center gap-2 mb-7">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75" style={{ animation: "pulse-ring 2s infinite" }} />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-400" />
            </span>
            <span className="text-xs font-semibold tracking-[0.22em] text-teal-300 uppercase">
              {HERO.eyebrow}
            </span>
          </div>

          <h1 className="reveal font-display font-extrabold text-white leading-[1.05] text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tight">
            {HERO.titleLead}{" "}
            <span className="text-gradient-teal">{HERO.titleAccent}</span>{" "}
            {HERO.titleTail}
          </h1>

          <p className="reveal mt-8 text-base sm:text-lg text-slate-300/90 leading-relaxed max-w-3xl">
            {HERO.description}
          </p>

          <div className="reveal mt-10 flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => scrollTo("#contact")}
              className="group bg-gradient-to-r from-teal-400 to-emerald-500 hover:from-teal-300 hover:to-emerald-400 text-[#04100f] font-semibold rounded-lg px-7 h-12 text-base shadow-lg shadow-teal-500/20"
            >
              Partner with GBB LLC
              <ArrowRight size={18} className="ml-1 transition-transform group-hover:translate-x-1" />
            </Button>
            <Button
              onClick={() => scrollTo("#advisory")}
              variant="outline"
              className="group bg-white/5 border-teal-500/25 text-white hover:bg-white/10 hover:border-teal-400/40 rounded-lg px-7 h-12 text-base backdrop-blur"
            >
              Explore Strategic Advisory
              <MoveRight size={18} className="ml-1 text-teal-300 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>

          {/* Vertical badges */}
          <div className="reveal mt-16 flex flex-wrap gap-x-10 gap-y-4">
            {["Capital Advisory", "KnowMo \u2014 Cash Intelligence", "Ember \u2014 Flare Compute"].map((t, i) => (
              <div key={i} className="flex items-center gap-2.5 text-sm text-slate-400">
                <span className="h-1.5 w-1.5 rounded-full bg-teal-400" />
                {t}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2">
        <span className="text-[10px] tracking-[0.25em] text-slate-500 uppercase">Scroll</span>
        <span className="h-10 w-px bg-gradient-to-b from-teal-400/60 to-transparent" />
      </div>
    </section>
  );
}